import { render } from "./ChampionshipStats.vue?vue&type=template&id=94a4d03a&scoped=true"
import script from "./ChampionshipStats.vue?vue&type=script&lang=js"
export * from "./ChampionshipStats.vue?vue&type=script&lang=js"

import "./ChampionshipStats.vue?vue&type=style&index=0&id=94a4d03a&scoped=true&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94a4d03a"]])

export default __exports__